import React from 'react';
import { Loader2, Search, CheckCircle2, Info } from 'lucide-react';

/**
 * SIRET/SIREN/raison sociale lookup bar — calls the
 * recherche-entreprises.api.gouv.fr API via the backend proxy.
 * Extracted from CompanyFormDialog (Vague 97.4).
 */
export default function CompanyLookupBar({ lookupQuery, setLookupQuery, looking, runLookup, lookupInfo, values }) {
  return (
    <section className="rounded-xl border border-[#EFF0F6] bg-[#FAFAFE] p-4">
      <label className="block text-[11.5px] font-semibold text-[#6B6C85] mb-2 tracking-wide uppercase">Recherche automatique</label>
      <div className="flex gap-2 items-start">
        <div className="flex-1">
          <input
            data-testid="company-siret-input"
            value={lookupQuery}
            onChange={(e) => setLookupQuery(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); runLookup(); } }}
            placeholder="SIRET (14 chiffres) · SIREN (9 chiffres) · ou raison sociale"
            className="w-full h-10 px-3 rounded-xl border border-[#EFF0F6] bg-white text-[13.5px] focus:border-[#4F46E5] outline-none"
          />
          <p className="text-[11px] text-[#8E8FA5] mt-1">
            Ex : <code>54205118000066</code> (SIRET) · <code>542051180</code> (SIREN) · « TotalEnergies »
          </p>
        </div>
        <button
          type="button"
          onClick={runLookup}
          disabled={looking}
          data-testid="company-sirene-lookup"
          className="h-10 px-4 rounded-xl brand-gradient text-white text-[12.5px] font-semibold inline-flex items-center gap-1.5 shadow-sm disabled:opacity-60 whitespace-nowrap"
        >
          {looking ? <Loader2 className="w-4 h-4 animate-spin" /> : <Search className="w-4 h-4" />}
          {looking ? 'Recherche…' : 'Rechercher'}
        </button>
      </div>
      {lookupInfo && (
        <div className="mt-2 text-[11.5px] text-[#4A4B63] flex items-center gap-3 flex-wrap" data-testid="sirene-lookup-info">
          {lookupInfo.isActive ? (
            <span className="inline-flex items-center gap-1 text-[#0F766E] font-semibold"><CheckCircle2 className="w-3.5 h-3.5" /> Active</span>
          ) : (
            <span className="inline-flex items-center gap-1 text-[#B91C1C] font-semibold"><Info className="w-3.5 h-3.5" /> Cessée</span>
          )}
          {lookupInfo.createdDate && <span className="text-[#6B6C85]">Créée le {lookupInfo.createdDate}</span>}
          {values.siren && <span className="text-[#6B6C85]">SIREN {values.siren}</span>}
          {values.naf_code && <span className="text-[#6B6C85]">NAF {values.naf_code}</span>}
        </div>
      )}
    </section>
  );
}
